import type {FC, PropsWithChildren} from 'react';
import {useMemo} from 'react';
import type {Schema} from 'schemaDefinition/types';
import {Card} from 'components/card';
import {DefaultContainer} from '../components/DefaultContainer';
import {MinimalIndentContainer} from '../components/MinimalIndentContainer';
import {useDataFormConfigurationContext} from '../contexts/DataFormConfigurationContext';

const NoContainer: FC<PropsWithChildren> = ({children}) => <>{children}</>;

export const useSchemaContainer = (schema: Schema): FC<PropsWithChildren> => {
  const configuration = useDataFormConfigurationContext();
  return useMemo(() => {
    const container =
      configuration.schemaContainers?.[schema.name] ??
      configuration.schemaContainers?.defaultContainer;

    return container === undefined || container === 'DefaultCard'
      ? DefaultContainer
      : container === 'NoContainer'
        ? NoContainer
        : container === 'MinimalIndentContainer'
          ? MinimalIndentContainer
          : ((({children}) => (
              <Card {...container}>
                <Card.Content>{children}</Card.Content>
              </Card>
            )) as FC<PropsWithChildren>);
  }, [configuration.schemaContainers, schema.name]);
};
